import React from "react";
import {Image} from "@chakra-ui/react";
import {Color} from "util/Color";

export const MainBanner = React.memo(() => {
    return <Image w="full" src={require("./asset/main-banner.jpg")} borderBottomStyle="dashed" borderBottomWidth="1px" borderBottomColor={Color.happyPiglets} />;
});
